define('multiselectView',[
  'module',
  'marionette',
  'underscore',
  'inputView',
  'selectOptionView'
], function (
  Module,
  Marionette,
  _,
  InputView,
  SelectOptionView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    className: 'select-view ' + InputView.prototype.className,
    tagName: 'select',
    childView: SelectOptionView,

    attributes: function () {
      return _.extend({}, InputView.prototype.attributes.apply(this, arguments), {
        multiple: true
      });
    },

    events: {
      'change': 'onChange'
    },

    initialize: function() {
      // No default selection enforced for multi-select
    },

    // Returns array of selected ids (strings)
    getSelected: function () {
      var values = this.$el.val() || [];
      // Ensure array of strings
      if (!Array.isArray(values)) values = [values];
      return values;
    },

    // Accepts array of ids or CSV string
    setSelected: function (ids) {
      var values = [];
      if (!ids) {
        values = [];
      } else if (Array.isArray(ids)) {
        values = ids;
      } else if (typeof ids === 'string') {
        if (ids.indexOf(',') !== -1) values = _.filter(ids.split(','), function(v){ return v !== ''; });
        else values = ids === '' ? [] : [ids];
      } else {
        values = [ids.toString()];
      }

      this.$el.val(values);

      // Reflect selection on models for consistency
      _.each(this.collection.models, function(model) {
        if (values.indexOf(model.get('id')) !== -1)
          model.set('selected', true);
        else
          model.set('selected', false);
      });
    },

    clearSelected: function() {
      this.setSelected([]);
    },

    onChange: function() {
      var values = this.getSelected();
      // Update models
      _.each(this.collection.models, _.bind(function(model) {
        if(values.indexOf(model.get('id').toString()) !== -1)
          model.set('selected', true);
        else
          model.set('selected', false);
      }, this));

      this.trigger('change', values);
    }
  }, InputView);
});

